import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
  exchangeSession: (sessionId) => api.post('/auth/session', { session_id: sessionId }),
};

// Listings API
export const listingsAPI = {
  getAll: (params) => api.get('/listings', { params }),
  getById: (id) => api.get(`/listings/${id}`),
  create: (data) => api.post('/listings', data),
  update: (id, data) => api.put(`/listings/${id}`, data),
  delete: (id) => api.delete(`/listings/${id}`),
  claim: (id, data) => api.post(`/listings/${id}/claim`, data),
};

// Reviews API
export const reviewsAPI = {
  getAll: (params) => api.get('/reviews', { params }),
  create: (data) => api.post('/reviews', data),
  flag: (id) => api.post(`/reviews/${id}/flag`),
  // Review Responses (conversation thread)
  getResponses: (reviewId) => api.get(`/reviews/${reviewId}/responses`),
  createResponse: (reviewId, text) => api.post(`/reviews/${reviewId}/responses`, { review_id: reviewId, text }),
  deleteResponse: (responseId) => api.delete(`/reviews/responses/${responseId}`),
};

// SEO API
export const seoAPI = {
  get: (pageType, pageId) => api.get(`/seo/${pageType}/${pageId}`),
  update: (pageType, pageId, data) => api.put(`/seo/${pageType}/${pageId}`, data),
  getAll: (pageType) => api.get('/seo/all', { params: { page_type: pageType } }),
};

// Static Pages API
export const pagesAPI = {
  getAll: () => api.get('/pages'),
  getBySlug: (slug) => api.get(`/pages/${slug}`),
  create: (data) => api.post('/pages', data),
  update: (slug, data) => api.put(`/pages/${slug}`, data),
  delete: (slug) => api.delete(`/pages/${slug}`),
};

// Cities API
export const citiesAPI = {
  getAll: () => api.get('/cities'),
  getBySlug: (slug) => api.get(`/cities/${slug}`),
};

// Specialties API
export const specialtiesAPI = {
  getAll: () => api.get('/specialties'),
  getBySlug: (slug) => api.get(`/specialties/${slug}`),
};

// User API
export const userAPI = {
  getFavorites: () => api.get('/user/favorites'),
  addFavorite: (listingId) => api.post(`/user/favorites/${listingId}`),
  removeFavorite: (listingId) => api.delete(`/user/favorites/${listingId}`),
  getListings: () => api.get('/user/listings'),
  getReviews: () => api.get('/user/reviews'),
};

// Admin API
export const adminAPI = {
  getListings: (params) => api.get('/admin/listings', { params }),
  approveListing: (id) => api.put(`/admin/listings/${id}/approve`),
  rejectListing: (id) => api.put(`/admin/listings/${id}/reject`),
  featureListing: (id, featured) => api.put(`/admin/listings/${id}/feature`, null, { params: { featured } }),
  getClaims: (status) => api.get('/admin/claims', { params: { status } }),
  approveClaim: (id) => api.put(`/admin/claims/${id}/approve`),
  rejectClaim: (id) => api.put(`/admin/claims/${id}/reject`),
  getReviews: (status) => api.get('/admin/reviews', { params: { status } }),
  approveReview: (id) => api.put(`/admin/reviews/${id}/approve`),
  deleteReview: (id) => api.delete(`/admin/reviews/${id}`),
  getUsers: (params) => api.get('/admin/users', { params }),
  updateUserRole: (id, role) => api.put(`/admin/users/${id}/role`, null, { params: { role } }),
  createCity: (data) => api.post('/admin/cities', data),
  createSpecialty: (data) => api.post('/admin/specialties', data),
  getQuestions: (status) => api.get('/admin/questions', { params: { status } }),
  deleteQuestion: (id) => api.delete(`/questions/${id}`),
};

// Payments API
export const paymentsAPI = {
  createCheckout: (data) => api.post('/payments/checkout', { ...data, origin_url: window.location.origin }),
  getStatus: (sessionId) => api.get(`/payments/status/${sessionId}`),
};

// Analytics API
export const analyticsAPI = {
  getListingAnalytics: (listingId) => api.get(`/analytics/listing/${listingId}`),
  track: (data) => api.post('/analytics/track', data),
};

// Q&A API
export const questionsAPI = {
  getAll: (listingId) => api.get(`/questions?listing_id=${listingId}`),
  create: (data) => api.post('/questions', data),
  answer: (questionId, data) => api.post(`/questions/${questionId}/answer`, data),
  delete: (questionId) => api.delete(`/questions/${questionId}`),
};

// Stats API
export const statsAPI = {
  get: () => api.get('/stats'),
};

// Seed API
export const seedAPI = {
  seed: () => api.post('/seed'),
};

export default api;
